import { Component, Input } from '@angular/core';
import { AnimationOptions } from 'ngx-lottie';
import { HourFormatService } from 'src/app/aplication/api/Infra/HourFormat.service';
import { ProcessDto } from 'src/app/aplication/api/Manipulate/ProcessDto';
import { ProcessosService } from 'src/app/aplication/api/Services/Process.service';

@Component({
  selector: 'app-stopwatch',
  templateUrl: './stopwatch.component.html',
  styleUrl: './stopwatch.component.scss'
})
export class StopwatchComponent {
  loaded:boolean = false;
  animationStopwatch: AnimationOptions = {
    path: 'assets/Animations/animationStopwatch.json',
  };
  private _momentCompare !: Date|string;
  public get momentCompare() : Date|string{
    return this._momentCompare;
  }
   public set momentCompare(v : Date|string) {
    this._momentCompare = v;
    //console.log(v);
   
  }
  
  private _processSelected !: ProcessDto;
  public get processSelected() : ProcessDto {
    return this._processSelected;
  }
  @Input() public set processSelected(v : ProcessDto) {
    this._processSelected = v;
    setTimeout(() => {
      this.loaded = true;
    }, 500);
    if(v.initPendentTime){
      //console.log('Data sem formatação' + v.initPendentTime);
      var formatHour=this._hourFormatService.utcTolocalDate(v.initPendentTime.toString());
      //console.log('Data com formatação' + formatHour);
      
      this.startTimer(formatHour);
    }
  }
  
  elapsedTime: string = '00:00';  // Para exibir os minutos e segundos

  private startTime: Date = new Date();  // Tempo de início

  constructor(private _hourFormatService: HourFormatService, private _processService: ProcessosService) { }

  ngOnInit(moment:Date): void {
  }
  public FinalizarStopwatch(){
    if(this.processSelected.id){
      this._processService.AtualizarStatusProcesso(this.processSelected.id,7).subscribe();
    }
  }
  startTimer(moment: Date): void {
    setInterval(() => {
      const currentTime = new Date();
      const elapsedMilliseconds = currentTime.getTime() - moment.getTime();
  
      // Calcula as horas, minutos e segundos
      const elapsedHours = Math.floor((elapsedMilliseconds / (1000 * 60 * 60)));
      const elapsedMinutes = Math.floor((elapsedMilliseconds / (1000 * 60)) % 60);
      const elapsedSeconds = Math.floor((elapsedMilliseconds / 1000) % 60);
  
      // Formata as horas, minutos e segundos como HH:MM:SS
      this.elapsedTime = 
        this.padZero(elapsedHours) + ':' + 
        this.padZero(elapsedMinutes) + ':' + 
        this.padZero(elapsedSeconds);
    }, 1000);  // Atualiza a cada segundo
  }
  

  // Adiciona um zero à esquerda para números menores que 10
  padZero(value: number): string {
    return value < 10 ? '0' + value : value.toString();
  }
}
